import(/* webpackMode: "eager" */ "/codebuild/output/src4182669429/src/src/app/global-error.tsx");
